var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-1 -1 18 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6663 16.5V14.8333C14.6663 13.9493 14.3152 13.1014 13.69 12.4763C13.0649 11.8512 12.2171 11.5 11.333 11.5H4.66634C3.78229 11.5 2.93444 11.8512 2.30932 12.4763C1.6842 13.1014 1.33301 13.9493 1.33301 14.8333V16.5M11.333 4.83333C11.333 6.67428 9.84062 8.16667 7.99967 8.16667C6.15873 8.16667 4.66634 6.67428 4.66634 4.83333C4.66634 2.99238 6.15873 1.5 7.99967 1.5C9.84062 1.5 11.333 2.99238 11.333 4.83333Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user.970ec967.svg";
export { ForwardRef as ReactComponent };